import { useEffect } from 'react';

import { WebSocketWrapper } from '@zg-rentals/particles-js-websocket-wrapper';

/**
 * Sets up the global rental-manager-api websocket instance.
 * This websocket is used for real-time updates like listing syndication status.
 *
 * Usage: Call this hook once in _app.tsx to set up the global websocket.
 */
export const useRentalManagerWebSocket = () => {
  useEffect(() => {
    // Only run on client side
    if (typeof window === 'undefined') return;

    const isDevelopment = process.env.NODE_ENV === 'development';

    // In development, use a mock websocket to avoid connection errors
    if (isDevelopment) {
      window.rentalManagerApiWebSocket = {
        addEventListener: () => {},
        removeEventListener: () => {},
        close: () => {},
      } as unknown as WebSocketWrapper;

      return;
    }

    // Get hostname from current location
    const hostname = window.location.hostname;

    // Create websocket connection
    window.rentalManagerApiWebSocket = new WebSocketWrapper({
      url: `wss://${hostname}/rental-manager-api/ws/services`,
      maxReconnect: 60000 * 5, // Wait up to 5 minutes before trying to reconnect
    });

    // Cleanup on unmount
    return () => {
      if (window.rentalManagerApiWebSocket) {
        window.rentalManagerApiWebSocket.close();
      }
    };
  }, []);
};
